export default "__VITE_PUBLIC_ASSET__9c4fb885__"